module.exports = __webpack_public_path__ + "img/uko-victor.71006b1a.jpg";